import { useEffect } from 'react'

export const FixIosKeyboardOverflow = () => {
  useEffect(() => {
    if (!('visualViewport' in window)) return

    const vv = visualViewport
    if (!vv) return

    const handleResize = () => {
      const focusedInput = document.activeElement
      if (!focusedInput) return

      const boundingRect = focusedInput.getBoundingClientRect()

      const isInputInViewport = boundingRect.bottom <= vv.height
      if (isInputInViewport) return

      window.scrollTo({
        top: boundingRect.top + boundingRect.height / 2 - vv.height / 2,
        behavior: 'smooth',
      })
    }
    vv.addEventListener('resize', handleResize)

    return () => vv.removeEventListener('resize', handleResize)
  }, [])

  return null
}
